import React from 'react';
import { connect } from 'react-redux';
import { openOrderJournalDetailDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '@/components/DataTable/DataTable';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

class OrderHistory extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      data: null,
      columnDefs: [
        {
          headerName: props.language.common_order_id,
          colId: 'common_order_id',
          field: 'orderGroupID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          cellRendererParams: {
            action: this.handleViewOrderDetail
          }
        },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'instrumentID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            market: 'marketID',
            instrument: 'instrumentID'
          }
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'instrumentName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.STOCK_NAME,
          cellRendererParams: {
            stockName: 'instrumentName',
            chineseStockName: 'instrumentChineseName'
          }
        },
        {
          headerName: props.language.common_buy_sell,
          colId: 'common_buy_sell',
          field: 'bs',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell text-center',
          dataType: dataType.ORDER_CELL_RENDER
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY
        },
        {
          headerName: props.language.common_quantity,
          colId: 'common_quantity',
          field: 'qty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          minWidth: 160

        },
        {
          headerName: props.language.common_filled_qty,
          colId: 'common_filled_quantity',
          field: 'filledQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          minWidth: 160
        },
        {
          headerName: props.language.common_avg_price,
          colId: 'common_avg_price',
          field: 'avgPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          minWidth: 160

        },
        {
          headerName: props.language.common_status,
          colId: 'common_status',
          field: 'status',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 120,
        },
        {
          headerName: props.language.common_order_type,
          colId: 'common_order_type',
          field: 'orderType',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 200
        },
        {
          headerName: props.language.common_create_time,
          colId: 'common_create_time',
          field: 'inputTime',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          minWidth: 170
        }
      ],
      dateFilter: null
    }
  }
  render() {
    const { data, columnDefs } = this.state;
    return (
      <div className="order-history-container" style={{ flexGrow: 1 }}>
        <DataTable
          name={TABLE_CONFIGURABLE_KEYS.TRADE_PORTFOLIO_ORDER_HISTORY}
          innerRef={e => this.tableRef = e}
          columnDefs={columnDefs}
          data={data}
        />
      </div>
    )
  }

  handleViewOrderDetail = (order) => {
    openOrderJournalDetailDialog(order, this.state.dateFilter, true)
  }

  getData(status = '', startDate = '', endDate = '') {
    this.setState({data:[]})
    const { currentTradingAccount, language ,token} = this.props
    if (currentTradingAccount.clientID) {
      if (this.tableRef) {
        this.tableRef.toggleLoadingOverlay(true);
      }

      let dateFilter = {
        startDate: startDate,
        endDate: endDate
      }

      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: status,
        [PARAMS.START_DATE]: startDate,
        [PARAMS.END_DATE]: endDate,
        [PARAMS.LANGUAGE]: language.lang,
      }

      this.setState({ dateFilter: dateFilter })

      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ data: res.result.orderInfoList });
          } else {
            this.setState({
              data: []
            })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  getYesterday() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  componentDidMount() {
    this.getData('', this.getYesterday(), this.getYesterday());
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
  	if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
    	// this.getData('', this.getYesterday(), this.getYesterday());
  	}
  }
}

OrderHistory.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    token: state.auth.token
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderHistory)
